<template>
    <div class="o-start start">
        <OStartTiles :view="view"/>
    </div>
</template>

<script>
export default {
    name: 'OStart',
    components: {
        OStartTiles: () => import('../../unique-organisms/o-start-tiles'),
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "o-start";
</style>
